import React from 'react';
import PropTypes from 'prop-types';
import WelcomeOnboarding from './WelcomeOnboarding';
import ComodinesOnboarding from './ComodinesOnboarding';

// Mapea cada variante de onboarding a su componente (markup propio).
const VARIANTS = {
  welcome: WelcomeOnboarding,
  comodines: ComodinesOnboarding,
};

/**
 * Dispatcher: renderiza el componente correspondiente al onboarding actual.
 * El markup de cada uno vive en su propio componente; comparten CSS y el shell.
 */
export const OnboardingModal = ({ onboarding, userEmail, onClose, onGoToRules }) => {
  const Variant = VARIANTS[onboarding.variant] || WelcomeOnboarding;
  return (
    <Variant
      slides={onboarding.slides}
      userEmail={userEmail}
      onClose={onClose}
      onGoToRules={onGoToRules}
    />
  );
};

OnboardingModal.displayName = 'OnboardingModal';
OnboardingModal.propTypes = {
  onboarding: PropTypes.shape({
    variant: PropTypes.string,
    slides: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  userEmail: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onGoToRules: PropTypes.func.isRequired,
};
OnboardingModal.defaultProps = {
  userEmail: '',
};

export default OnboardingModal;
